/**
 * Iconos del menú y de las acciones — bloque 1 (2026-09-18).
 *
 * SVG en línea, dibujados con `currentColor`: heredan el color del texto (y por
 * tanto los tokens y el modo oscuro) y no piden nada a ninguna red (la CSP sólo
 * permite `'self'`). Son decorativos: siempre acompañan a un texto, así que van
 * con `aria-hidden` y no necesitan nombre propio.
 */

export type NombreIcono =
  | "inicio"
  | "emisor"
  | "clientes"
  | "productos"
  | "presupuestos"
  | "seguridad"
  | "cuenta"
  | "plan"
  | "buscar"
  | "mas"
  | "ajustes"
  | "salir"
  | "menu"
  | "facturas"
  | "soporte"
  | "campana"
  | "siguiente"
  // OD-0048: las oportunidades del CRM. Una linea que sube.
  | "oportunidades"
  // OD-0050: tareas y actividades. Una casilla marcada.
  | "tareas"
  // OD-0041: informes fiscales.
  | "informes"
  // OD-0054: facturas de compra. Una bolsa de la compra.
  | "compras"
  // OD-0057: importar desde Excel. Una flecha que entra en una bandeja.
  | "importar";

const TRAZOS: Readonly<Record<NombreIcono, readonly string[]>> = {
  inicio: ["M3 11 12 4l9 7", "M5 10v10h14V10", "M10 20v-6h4v6"],
  emisor: ["M4 21V5l8-2v18", "M12 9h8v12", "M7 8h2", "M7 12h2", "M7 16h2", "M15 13h2", "M15 17h2", "M2 21h20"],
  clientes: ["M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z", "M2 21c0-4 3-7 7-7s7 3 7 7", "M16 3.5a4 4 0 0 1 0 7.5", "M18 14c2.5.8 4 3.4 4 7"],
  productos: ["M12 3 3 7.5v9L12 21l9-4.5v-9z", "M3 7.5 12 12l9-4.5", "M12 12v9"],
  presupuestos: ["M6 3h9l4 4v14H6z", "M14 3v5h5", "M9 12h7", "M9 16h7"],
  seguridad: ["M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z", "m9 12 2 2 4-4"],
  cuenta: ["M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z", "M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7"],
  plan: ["M3 6h18v12H3z", "M3 10h18", "M7 14h4"],
  buscar: ["M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z", "m21 21-5-5"],
  mas: ["M12 5v14", "M5 12h14"],
  oportunidades: ["M3 17l6-6 4 4 8-8", "M15 7h6v6"],
  tareas: ["M4 4h16v16H4z", "m8 12 3 3 5-6"],
  // OD-0041: tres barras sobre su eje. Un informe, no una tendencia.
  informes: ["M4 20h16", "M7 20v-6", "M12 20V8", "M17 20v-9"],
  compras: ["M5 8h14l-1 13H6z", "M9 8V6a3 3 0 0 1 6 0v2"],
  importar: ["M12 3v12", "M7 10l5 5 5-5", "M4 15v5h16v-5"],
  menu: ["M4 6h16", "M4 12h16", "M4 18h16"],
  campana: ["M6 16V11a6 6 0 0 1 12 0v5l2 2H4z", "M10 21h4"],
  siguiente: ["m9 6 6 6-6 6"],
  facturas: ["M6 3h12v18l-3-2-3 2-3-2-3 2z", "M9 8h6", "M9 12h6", "M9 16h3"],
  soporte: ["M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z", "M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.6v.6", "M12 17h.01"],
  salir: ["M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3", "M10 17l-5-5 5-5", "M5 12h11"],
  ajustes: [
    "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    "M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z",
  ],
};

export function Icono({ nombre }: { nombre: NombreIcono }) {
  return (
    <svg
      className="icono"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {TRAZOS[nombre].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
